import React, { useEffect, useState } from "react";
import loginAPIMethod from "../../utils/services/login.api";
import { useAuth } from "../../utils/AuthContext";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  Box,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  IconButton,
  Typography,
  Stack,
  Button,
  Grid2,
  Link,
} from "@mui/material";
import AlertMessage from "../../components/common/AlertMessage";
import { getStorageValue, setStorageValue, deleteAllStorageValue, loginVariableSetting, setEncryptedStorageValue, getEncryptedPassword } from "../../utils/helper";
import NotificationsListAPI from "../../utils/services/notifications.api";
import "../../styles/LoginPage.css";
import Loaders from "../../components/common/Loaders";
import { LoginSchema } from "../../utils/schema/completeProfileSchema";

function Login() {
  const { adminLogin } = loginAPIMethod;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(
    getStorageValue("username") ? true : false
  );
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;

  const formik = useFormik({
    initialValues: {
      username: getStorageValue("username"),
      password: getEncryptedPassword("password"),
    },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const loginRequest = {
        email: values.username?.trim(),
        password: values.password?.trim(),
      };
      const response = await adminLogin(loginRequest);
      if (response.status === "success") {
        setLoading(false);
        if (rememberMe) {
          setStorageValue("username", values.username);
          setEncryptedStorageValue("password", values.password);
        } else {
          deleteAllStorageValue("username", "password")
        }
        login();
        loginVariableSetting(response.data);
        getUnreadNotification(response.data.id);
        navigate("/dashboard");
      } else if (response.status === "error") {
        setLoading(false);
        setOpen(true);
      }
    },
  });

  const getUnreadNotification = async (userId) => {
    const checkDate = new Date()?.toISOString();
    const response = await checkUnreadNotifications(userId, checkDate);
    if (response.status !== "success") {
      localStorage.setItem("notifications", false);
    } else {
      if (localStorage.getItem("isClicked") !== "true") {
        localStorage.setItem("notifications", response?.data?.message);
        localStorage.setItem("isReload", response?.data?.message);
      }
    }
  };

  const isNotSpace = (event) => {
    if (!isNaN(event.keyCode) && event.keyCode === 32) {
      event.preventDefault();
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function success(position) {
      setStorageValue("latitude", position.coords.latitude);
      setStorageValue("longitude", position.coords.longitude);
  }

  useEffect(() => {
    deleteAllStorageValue("latitude", "longitude")
    navigator.geolocation.getCurrentPosition(success);
    localStorage.removeItem("isClicked");
    localStorage.removeItem("isReload");
    localStorage.removeItem("notifications");
    // eslint-disable-next-line
  }, []);

  return (
    <Stack className="bg">
      {loading && (
        <Loaders />
      )}
      <Grid2>
        <img
          src={require("../../assets/images/login_illustration.png")}
          className="img2"
          alt="img2"
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          className="box-element"
          autoComplete="off"
        >
          <Box sx={{ display: "grid", width: "100%", paddingLeft: "2.5rem", paddingRight: "2.5rem", padding: "2rem" }}>
            <Box sx={{ paddingBottom: "6rem" }}>
              <img
                src={require("../../assets/logos/a2b-logo.svg").default}
                alt="a2bLogoImage"
                style={{ position: "absolute" }}
                width="82%"
                height="60px"
                onDragStart={(e) => {
                  e.preventDefault();
                }}
              />
            </Box>
            <Typography
              sx={{ fontWeight: "600", color: "#101828" }}
              variant="h5"
            >
              Admin Login
            </Typography>
            <Typography
              sx={{ marginTop: "1rem", color: "#475467" }}
              variant="body2"
            >
              Use your work email ID and password to proceed with your login
            </Typography>
            <InputLabel
              sx={{ marginTop: "1.5rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
              htmlFor="outlined-adornment-EmailID"
            >
              Email ID
            </InputLabel>
            <OutlinedInput
              sx={{ height: "38px", marginTop: "2px" }}
              id="username"
              autoFocus
              placeholder="Enter your Email ID"
              inputProps={{ maxLength: 55 }}
              autoComplete="off"
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={require("../../assets/logos/mail.svg").default}
                    alt="test"
                    width="16px"
                    height="18px"
                    onDragStart={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputAdornment>
              }
              value={formik.values.username}
              error={formik.touched.username && formik.errors.username}
              onChange={formik.handleChange}
              onKeyDown={(e) => isNotSpace(e)}
            />
            {formik.touched.username && formik.errors.username && (
              <div style={{ color: "#F04438" }}>{formik.errors.username}</div>
            )}
            <InputLabel
              sx={{ marginTop: "1rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
              htmlFor="outlined-adornment-password"
            >
              Password
            </InputLabel>
            <OutlinedInput
              sx={{ height: "38px", marginTop: "2px" }}
              id="password"
              placeholder="Enter your Password"
              type={showPassword ? "text" : "password"}
              inputProps={{ maxLength: 55 }}
              autoComplete="off"
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={require("../../assets/logos/Password.svg").default}
                    alt="test"
                    width="16px"
                    height="18px"
                    onDragStart={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? (
                      <img
                        src={require("../../assets/logos/eye_open.svg").default}
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    ) : (
                      <img
                        src={
                          require("../../assets/logos/eye_close.svg").default
                        }
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              value={formik.values.password}
              error={formik.touched.password && formik.errors.password}
              onChange={formik.handleChange}
              onKeyDown={(e) => isNotSpace(e)}
            />
            {formik.touched.password && formik.errors.password && (
              <div style={{ color: "#F04438" }}>{formik.errors.password}</div>
            )}
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "0.5rem",
              }}
            >
              <FormControlLabel
                label={<span style={{ color: "#344054", fontSize: '15px', fontWeight: "400" }}>Remember me</span>}
                control={
                  <Checkbox
                    sx={{ fontSize: "14px" }}
                    size="small"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                }
              />
              <Link
                href="/ForgotPassword"
                sx={{
                  paddingTop: "0.5rem",
                  fontSize: "14px",
                  color: "#0C68F4",
                  fontWeight: '600'
                }}
                underline="always"
                onDragStart={(e) => {
                  e.preventDefault();
                }}
              >
                Forgot Password
              </Link>
            </Box>
            <Button
              variant="contained"
              type="submit"
              style={{
                textTransform: "none",
                marginTop: "2rem",
                backgroundColor: "#0C68F4",
              }}
              onClick={formik.handleSubmit}
            >
              Sign In
            </Button>
            <Box sx={{ marginTop: "20px" }} className="center-align">
              <Typography variant="bold2"
                  sx={{
                      fontSize: "14px",
                      fontWeight: "500"
                  }}
              >
                  Login as{" "}
                  <Link
                    component="button"
                    sx={{
                        fontSize: "14px",
                        color: "#0C68F4",
                        textDecorationColor: "#0C68F4",
                        textDecorationThickness: "1px",
                        textUnderlineOffset: "3px"
                    }}
                    underline="always"
                    onClick={() => {
                        navigate("/");
                    }}
                >
                    Regular User
                </Link>
              </Typography>
              </Box>
          </Box>
        </Box>
      </Grid2>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message="Invalid Email ID or Password"
        severity="error"
      />
    </Stack>
  );
}

export default Login;
